<lib-dba-mat-dialog-title (cancelClick)="dialogRef.close()">
    {{language.serviceabschliessen | translationPipe}}
</lib-dba-mat-dialog-title>

<mat-dialog-content [formGroup]="formGroup">
    @if(loading){<lib-spinner-dialog></lib-spinner-dialog>}

    <mat-form-field appearance="fill">
        <mat-label>{{language.abschliessen | translationPipe}}</mat-label>
        <input matInput required [matDatepicker]="pickerabgeschlossen" formControlName="datumAbgeschlossenControl"
            [max]="maxDate">
        <mat-datepicker-toggle matSuffix [for]="pickerabgeschlossen"></mat-datepicker-toggle>
        <mat-datepicker #pickerabgeschlossen></mat-datepicker>
    </mat-form-field>

    <!--
    <mat-form-field>
        <mat-label>{{language.Bericht | translationPipe}}</mat-label>
        <textarea rows="5" matInput maxlength="500" formControlName="berichtControl"></textarea>
    </mat-form-field>
    -->

    <doc-documents [documentList]="documentList" [maxImageAmount]="8"></doc-documents>

    <mat-divider></mat-divider>

    @if(data.Intervall) {
    <mat-slide-toggle [(ngModel)]="followUp" [ngModelOptions]="{standalone: true}">
        {{language.folgeterminerstellen | translationPipe}}
    </mat-slide-toggle>
    }

    @if(followUp){
    <mat-form-field appearance="fill">
        <mat-label>{{language.folgetermin | translationPipe}}</mat-label>
        <input matInput required [matDatepicker]="pickerfolgetermin" formControlName="datumFolgeterminControl"
            [min]="maxDate">
        <mat-datepicker-toggle matSuffix [for]="pickerfolgetermin"></mat-datepicker-toggle>
        <mat-datepicker #pickerfolgetermin></mat-datepicker>
    </mat-form-field>
    }

    <lib-dba-mat-dialog-footer (saveClick)="Save()" (cancelClick)="dialogRef.close()"></lib-dba-mat-dialog-footer>
</mat-dialog-content>